import { Fragment, useEffect } from 'react'
import { NextSeo } from 'next-seo'

import withPage from '@/lib/page/withPage'

import withServiceLayout from '@/features/Services/layouts/withServiceLayout'
import ServiceSection from '@/features/Services/templates/ServiceSection'
import PriceSection from '@/features/Services/templates/PriceSection'

import { WhatYouGet } from '@/components/Landing'

import { RECRUITMENT_PRIVACY } from '@/features/Services/constants'
import { logEcommerce } from '@/lib/stats/gtm'

function RecruitmentPage() {
  useEffect(() => {
    logEcommerce('view_item', {
      items: [
        {
          item_id: 'Recruitment Policy',
          item_name: 'Recruitment Policy',
          quantity: 1,
        },
      ],
    })
  }, [])
  return (
    <Fragment>
      <NextSeo title="Recruitment Policy" />

      <ServiceSection data={RECRUITMENT_PRIVACY} />
      <PriceSection serviceName="RECRUITMENT_PRIVACY" />
      <WhatYouGet hideDecor primaryColor={RECRUITMENT_PRIVACY.PRIMARY_COLOR} />
    </Fragment>
  )
}

export default withPage()(withServiceLayout(RecruitmentPage))
